module.exports = __webpack_public_path__ + "static/media/UA.abd8b642.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/UA.svg
// module id = 382
// module chunks = 0